import { render, staticRenderFns } from "./ProviderRegistrationRequestForm.vue?vue&type=template&id=23adc2fa&"
import script from "./ProviderRegistrationRequestForm.vue?vue&type=script&lang=js&"
export * from "./ProviderRegistrationRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports